












































































































import {
  computed, defineComponent, PropType, ref, Ref, watch,
} from 'vue';
import DeleteTableDialog from '@/components/DeleteTableDialog.vue';
import TableDialog from '@/components/TableDialog.vue';
import DownloadDialog from '@/components/DownloadDialog.vue';

import store from '@/store';
import { App, CheckboxTable } from '@/types';

export default defineComponent({
  name: 'TablePanel',

  components: {
    DeleteTableDialog,
    TableDialog,
    DownloadDialog,
  },

  props: {
    workspace: {
      type: String as PropType<string>,
      required: true,
    },

    items: {
      type: Array as PropType<string[]>,
      required: true,
    },

    loading: {
      type: Boolean as PropType<boolean>,
      required: true,
    },

    apps: {
      type: Object as PropType<{ network_visualizations: App[]; table_visualizations: App[] }>,
      required: true,
    },
  },

  setup(props) {
    const checkbox: Ref<CheckboxTable> = ref({});
    const singleSelected: Ref<string | null> = ref(null);

    const checked = computed(() => Object.keys(checkbox.value).filter((d) => !!checkbox.value[d]));
    const selection = computed(() => (singleSelected.value !== null ? [singleSelected.value] : [...checked.value]));
    const upsetUrl = computed(() => {
      const foundApp = props.apps.table_visualizations.find((vis: App) => vis.name === 'Upset');

      return foundApp !== undefined ? foundApp.url : '';
    });

    function clearCheckboxes() {
      Object.keys(checkbox.value).forEach((key) => {
        checkbox.value[key] = false;
      });
    }

    async function cleanup() {
      singleSelected.value = null;
      await store.dispatch.fetchWorkspace(props.workspace);
      clearCheckboxes();
    }

    watch(() => props.workspace, () => clearCheckboxes());

    return {
      checkbox,
      singleSelected,
      selection,
      upsetUrl,
      cleanup,
    };
  },
});
